export default __webpack_public_path__ + "static/media/bi.77e1868a.svg";